module.exports = __webpack_public_path__ + "static/img/nav_logo.44cf30e0.png";